
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -23978.699 18.549 14.398"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_162_1","data-name":"Symbol 162 – 1","transform":"translate(-19907.385 -25506.001)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_7738","data-name":"Group 7738","transform":"translate(242 1216)"}},[_c('g',{attrs:{"id":"Group_5683","data-name":"Group 5683","transform":"translate(782.522 318.582)"}},[_c('circle',{attrs:{"id":"Ellipse_884","cx":"1.627","cy":"1.627","r":"1.627","data-name":"Ellipse 884","transform":"translate(3.186 1.582)","fill":"#444"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Path_3399","d":"M2 5.209A5.681 5.681 0 0 1 6.814 2a5.709 5.709 0 0 1 4.814 3.163","data-name":"Path 3399","transform":"translate(-2 -2)"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Path_3400","d":"M2 16a5.681 5.681 0 0 0 4.814 3.209 5.709 5.709 0 0 0 4.814-3.163","data-name":"Path 3400","transform":"translate(-2 -12.791)"}})]),_c('path',{staticClass:"cls-3",attrs:{"id":"Path_3408","d":"M12.853 6.336v-2.1a1.5 1.5 0 0 0-.84-1.354A11.6 11.6 0 0 0 7.415 2a11.16 11.16 0 0 0-4.575.91A1.47 1.47 0 0 0 2 4.241v8.5a1.5 1.5 0 0 0 .84 1.354A11.079 11.079 0 0 0 7.415 15l1.14-.048","data-name":"Path 3408","transform":"translate(773 310)"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Path_3409","d":"M2 33.7a9.958 9.958 0 0 0 5.415 1.377","data-name":"Path 3409","transform":"translate(773 285.699)"}}),_c('path',{staticClass:"cls-3",attrs:{"id":"Path_3410","d":"M2 15.9a9.958 9.958 0 0 0 5.415 1.377 9.9 9.9 0 0 0 5.414-1.377","data-name":"Path 3410","transform":"translate(773 299.344)"}})])])])
          )
        }
      }
    